import { render, staticRenderFns } from "./questions-info.vue?vue&type=template&id=a69bc3f2&"
import script from "./questions-info.vue?vue&type=script&lang=js&"
export * from "./questions-info.vue?vue&type=script&lang=js&"
import style0 from "./questions-info.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a69bc3f2')) {
      api.createRecord('a69bc3f2', component.options)
    } else {
      api.reload('a69bc3f2', component.options)
    }
    module.hot.accept("./questions-info.vue?vue&type=template&id=a69bc3f2&", function () {
      api.rerender('a69bc3f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/medical-manage/health-manage/questions-info.vue"
export default component.exports